import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'form' ]

  submitForm(event){
    let keyInput = document.getElementById('key')
    keyInput.value = event.currentTarget.value
    this.formTarget.submit()
  }
}

